import admin from './admin.json';
import ai from './ai.json';
import auth from './auth.json';
import cc from './cc.json';
import common from './common.json';
import complaints from './complaints.json';
import crm from './crm.json';
import demo from './demo.json';
import docs from './docs.json';
import guide from './guide.json';
import integrations from './integrations.json';
import measurement from './measurement.json';
import nav from './nav.json';
import queue from './queue.json';
import reporting from './reporting.json';
import showcase from './showcase.json';
import tour from './tour.json';
import validation from './validation.json';

export default { admin, ai, auth, cc, common, complaints, crm, demo, docs, guide, integrations, measurement, nav, reporting, queue, showcase, tour, validation };
